export const OPEN_FULLSCREEN_STREAM = 'stream/OPEN_FULLSCREEN_STREAM' as const;
export const CLOSE_FULLSCREEN_STREAM = 'stream/CLOSE_FULLSCREEN_STREAM' as const;
export const PIN_STREAM = 'stream/PIN_STREAM' as const;
export const UNPIN_STREAM = 'stream/UNPIN_STREAM' as const;
export const ADD_MATCH_ID = 'stream/ADD_MATCH_ID' as const;
export const DELETE_MATCH_ID = 'stream/DELETE_MATCH_ID' as const;
export const CLEAR_MATCH_IDS = 'stream/CLEAR_MATCH_IDS' as const;
export const ADD_NEAREST_MATCH_ID = 'stream/ADD_NEAREST_MATCH_ID' as const;

export const SET_LAST_PLAYED_STREAM_MATCH_ID = 'stream/SET_LAST_PLAYED_STREAM_MATCH_ID' as const;
export const REMOVE_LAST_PLAYED_STREAM_MATCH_ID = 'stream/REMOVE_LAST_PLAYED_STREAM_MATCH_ID' as const;

export const MATCH_TRACKER_CONTAINER = '#matchTracker' as const;
export const WIDGET_LOADER = '//widgets.sir.sportradar.com/e6ed44220c02382e5ef47cc6b8391a86/widgetloader' as const;

export const SET_LOAD_STATUS = 'stream/SET_LOAD_STATUS' as const;

export const CHANGE_VIEWER_MODE = 'stream/CHANGE_VIEWER_MODE' as const;
export const RESET_VIEWER_MODE = 'stream/RESET_VIEWER_MODE' as const;

// BETRADAR CONSTANTS

export const MIN_WIDTH_FOR_DOUBLE_MODE = 560; // px

// Panels with fixed height
export const MOMENTUM_HEIGHT = 32;
export const SCOREBOARD_HEIGHT = 64;
export const BOTTOM_MENU_HEIGHT = 35;

// Sport field in COMPACT mode without panels keeps ratio of 316 / 195 when being resized
export const COMPACT_BASE_WIDTH = 316;
export const COMPACT_BASE_HEIGHT = 195;

// Sport field in DOUBLE mode without panels keeps ratio of 620 / 193 when being resized
export const DOUBLE_BASE_WIDTH = 620;
export const DOUBLE_BASE_HEIGHT = 193;

export const PROMO_PERCENT_WIDTH = 0.405;
export const ASPECT_RATIO = 0.5625;
export const STREAM_HEADER_HEIGHT = 40;

export enum PlayerType {
    SWF = 'SWF',
    DOUYU = 'DOUYU',
    TWITCH = 'TWITCH',
    YOUTUBE = 'YOUTUBE',
    IFRAME = 'IFRAME',
}

export enum ViewerMode {
    'STREAM' = 'STREAM',
    'MATCH_TRACKER' = 'MATCH_TRACKER',
    'NONE' = 'NONE',
}
